
import { Component, Vue } from 'vue-property-decorator'
import AppButton from '@/components/AppButton.vue'
import { ChildComponentMixin } from '@/mixins'

@Component({
    components: {
        AppButton,
    },
})
export default class PartnersHeader extends ChildComponentMixin {
    private addPartnerClick() {
        this.$router.push('/partners/create')
    }
}
